import { useEffect } from 'react';
import { CssBaseline, Box } from '@mui/material';
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import theme from './theme';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CompanyProfile from './pages/CompanyProfile';
import MissionVision from './pages/MissionVision';
import Career from './pages/Career';
import SoftwareDevelopment from './pages/SoftwareDevelopment';
import DigitalTransformation from './pages/DigitalTransformation';
import ITConsulting from './pages/ITConsulting';
import CloudSolutions from './pages/CloudSolutions';
import Blog from './pages/Blog';
import BlogPostDetail from './pages/BlogPostDetail';
import VeriLobiProduct from './pages/VeriLobiProduct';
import BeachBotProduct from './pages/BeachBotProduct';

export default function App() {
  useEffect(() => {
    // Signal to prerender plugin that the page is ready
    document.dispatchEvent(new Event('render-event'));
  }, []);

  return (
    <CssVarsProvider theme={theme}>
      <BrowserRouter>
        <LanguageProvider>
          <CssBaseline />
          <Box component="div" sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />
            <Box sx={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about/company" element={<CompanyProfile />} />
                <Route path="/about/mission-vision" element={<MissionVision />} />
                <Route path="/about/career" element={<Career />} />
                <Route path="/services/software-development" element={<SoftwareDevelopment />} />
                <Route path="/services/digital-transformation" element={<DigitalTransformation />} />
                <Route path="/services/it-consulting" element={<ITConsulting />} />
                <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPostDetail />} />
                <Route path="/products/verilobi" element={<VeriLobiProduct />} />
                <Route path="/products/beachbot" element={<BeachBotProduct />} />
                <Route path="*" element={<HomePage />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        </LanguageProvider>
      </BrowserRouter>
    </CssVarsProvider>
  );
}